import React from "react";
import style from "./index.module.scss";
import { gradeChildItem } from "../../../../../API/scoreRule";
interface ScorePanelProps {
    data: gradeChildItem;
    title: string;
}

export default function ScorePanel({ data, title }: ScorePanelProps) {
    return (
        <div className={style.panel}>
            <div className={style.item}>
                <span className={style.icon} />
                <span className={style.name}>{data.name}</span>
            </div>
            <div className={style.item}>
                <span className={style.percent}>
                    (占总成绩的{data.grade}% )
                </span>
            </div>
            <div className={style.item}>
                <span className={style.label}>总分</span>
                <span className={style.score}>{data.score}</span>
                <span className={style.totalScore}>/&nbsp;{data.grade}分</span>
            </div>
        </div>
    );
}
